<template>
    <v-container>
        <v-card class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div class="Dtunes__workforce__main">
                        <h2>{{team.name}}</h2>
                        <p>Below are the teams you have created    </p>
                    </div>
                    <v-spacer></v-spacer>
                    <DepartmentPermissionModal style="margin-right:50px"   :details = "team" />
                   
                    <AddtoteamModal :team="team" @add-member="getTeam"/>
                </v-row>
                <team-table v-if="team.members.length > 0" :id="team.id" :team="team.members"/>
                <div v-if="team.members.length == 0" class="text-center">
                    <h2>No Members added yet to teams</h2>
                </div>
            </v-container>
            <!-- <dtunes-loader :loading="loading"></dtunes-loader> -->
        </v-card>
    </v-container>
</template>

<script>
// ============ IMPORT COMPONENTS =============
    import TeamTable from '../../components/team-table.vue'
    import AddtoteamModal from "../../components/add-to-team-modal.vue"
    
import DepartmentPermissionModal from '../../components/department-permission-modal.vue'
// import DtunesLoader from "@/components/dtunes-loader.vue"

// =========== IMPORT SERVICE ==============
import { TeamService } from "@/services";
export default {
    components:{
        TeamTable,
        AddtoteamModal,
        DepartmentPermissionModal
        // DtunesLoader
    },
    data: () => ({
        team:[],
        // loading:false
    }),
    mounted(){
        this.getTeam();
    },
    methods:{
        async getTeam(){
            try {
                const data = await TeamService.getTeam({
                id: this.$route.params.id
                });
                console.log('this is the data', data);
                this.team = data;
            } catch (error) {
                console.log(error);
            }
            
        }
    }
    
}
</script>


<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";

.Dtunes__workforce__main{
    h2{
        color:$Dtunes-text;
        font-size: 24px;
        font-weight: 500;
    }
    p{
        color: $Dtunes-grey;
        font-size: 14px;
    }
}
</style>